<script setup>
definePage({
  meta: {
    layout: 'default',
    action: 'read',
    subject: 'UserGuide',
  },
})

const guides = [
  {
    title: 'Meja & Denah Meja',
    route: 'userguide-fb-modern-tables',
    icon: 'ri-table-2',
    color: 'primary',
    description: 'Kelola meja, buka/gabung/tutup sesi, QR self-order, dan pisah tagihan (split bill)',
    available: true,
  },
  {
    title: 'Tipe Order & Biaya Layanan',
    route: 'userguide-fb-modern-order-type',
    icon: 'ri-percent-line',
    color: 'success',
    description: 'Dine-in, Takeaway, Delivery — dan biaya tambahan otomatis untuk masing-masing',
    available: true,
  },
  {
    title: 'Platform Delivery',
    route: 'userguide-fb-modern-delivery-platforms',
    icon: 'ri-motorbike-line',
    color: 'warning',
    description: 'Daftarkan GoFood, GrabFood, ShopeeFood, atau platform ojek online lainnya',
    available: true,
  },
  {
    title: 'Stasiun Dapur',
    icon: 'ri-fire-line',
    color: 'grey',
    description: 'Konfigurasi stasiun dapur/bar dan aturan routing pesanan',
    available: false,
  },
  {
    title: 'Kitchen Display (KDS)',
    icon: 'ri-tv-2-line',
    color: 'grey',
    description: 'Layar pantau pesanan real-time untuk dapur & bar',
    available: false,
  },
]
</script>

<template>
  <div>
    <RouterLink to="/userguide">
      <VBtn variant="text" prepend-icon="ri-arrow-left-line" class="mb-2">
        Kembali ke Daftar Modul
      </VBtn>
    </RouterLink>

    <div class="d-flex align-center mb-4">
      <VAvatar color="primary" variant="tonal" size="64" rounded="lg" class="me-4">
        <VIcon icon="ri-restaurant-2-line" size="36" />
      </VAvatar>
      <div>
        <h4 class="text-h4 font-weight-bold mb-1">F&B Modern</h4>
        <p class="text-body-1 text-medium-emphasis mb-0">
          Fitur khusus restoran & coffee shop: meja, tipe order, delivery, dan dapur
        </p>
      </div>
    </div>

    <VAlert type="info" variant="tonal" class="mb-6" icon="ri-information-line">
      Fitur di bagian ini dirancang khusus untuk bisnis F&B (restoran, coffee shop, kafe)
      yang punya konsep <strong>dine-in</strong> (makan di tempat), butuh atur meja,
      atau menerima pesanan dari layanan ojek online.
    </VAlert>

    <VRow>
      <VCol v-for="guide in guides" :key="guide.title" cols="12" md="6" lg="4">
        <VCard
          variant="outlined"
          :class="{ 'opacity-60': !guide.available }"
          :hover="guide.available"
        >
          <VCardText>
            <div class="d-flex align-center mb-3">
              <VAvatar :color="guide.color" variant="tonal" size="48" class="me-3">
                <VIcon :icon="guide.icon" size="26" />
              </VAvatar>
              <div>
                <h6 class="text-h6 font-weight-bold mb-0">{{ guide.title }}</h6>
                <VChip v-if="!guide.available" size="x-small" color="grey" class="mt-1">
                  Segera Hadir
                </VChip>
              </div>
            </div>
            <p class="text-body-2 text-medium-emphasis mb-4">
              {{ guide.description }}
            </p>
            <VBtn
              v-if="guide.available"
              :to="{ name: guide.route }"
              variant="tonal"
              :color="guide.color"
              block
            >
              Baca Panduan
            </VBtn>
            <VBtn v-else variant="tonal" color="grey" block disabled>
              Belum Tersedia
            </VBtn>
          </VCardText>
        </VCard>
      </VCol>
    </VRow>
  </div>
</template>
